import React, { memo, useMemo } from 'react';
import { getContext, Symbols } from 'choerodon-ui/shared';
import { getPrefixCls } from '../configure/utils';
const LayoutContext = getContext(Symbols.LayoutContext, { getPrefixCls });
const BaseLayoutContextProvider = function LayoutContextProvider(props) {
    const { children, siderHook, getPrefixCls: getGlobalPrefixCls } = props;
    const value = useMemo(() => ({
        siderHook,
        getPrefixCls: getGlobalPrefixCls,
    }), [getGlobalPrefixCls, siderHook]);
    return (React.createElement(LayoutContext.Provider, { value: value }, children));
};
BaseLayoutContextProvider.displayName = 'LayoutContextProvider';
export const LayoutContextProvider = memo(BaseLayoutContextProvider);
export default LayoutContext;
